
import React from 'react';
import "./style.css";
import {
  TextField,
  Grid,
  Typography,
} from "@mui/material";

const Section1 = (props) => {
  const { data, name } = props
  console.log('datahome',data)

  return (
    <Grid className='address_container' sx={{ display: 'flex' }}>
      <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
        <Grid  style={{ display: 'flex', flexDirection: 'row', padding: '20px', marginTop: "19px", border: '1px solid #E3E3E3', backgroundColor: '#FCFCFC',borderRadius: "6px",boxShadow: " 0px 3px 6px #A7A7A729", opacity:1 }}>
    
          <Grid >
            <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal',fontSize:'14px' }}>
              First name
            </label>
            <TextField
              style={{ fontFamily: 'Rubik', paddingBottom: '15px' }}
              size="small"
              InputProps={{ readOnly: true, style: {
                backgroundColor: "white"                 
              } }}
              // InputProps={{
              //   style: {
              //     backgroundColor: "red"                 
              //   },}}
              fullWidth
              disabled={false}
              focused={false}
              
              value={data.Username}

            />
            <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal',fontSize:'14px' }}>
              Email ID
            </label>
            <TextField
              style={{ fontFamily: 'Rubik' }}
              size="small"

              InputProps={{ readOnly: true, style: {
                backgroundColor: "white"                 
              } }}
              // placeholder="Add Last Name"
              fullWidth
              disabled={false}
              focused={false}

              value={data.email}

            />

          </Grid>
          <Grid sx={{ marginLeft: '40px' }} >
            <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal',fontSize:'14px' }}>
              Last name
            </label>
            <TextField
              style={{ fontFamily: 'Rubik', paddingBottom: '15px', }}
              InputProps={{ readOnly: true, style: {
                backgroundColor: "white"                 
              } }}
              size="small"
              disabled={false}
              focused={false}
              placeholder="Add Last Name"
              fullWidth

              value={data.Lastname}

            />
            <label htmlFor="name" style={{ fontFamily: 'Rubik', color: '#000000', fontWeight: 'normal',fontSize:'14px' }}>
              Contact number
            </label>
            <TextField
              style={{ fontFamily: 'Rubik' }}
              InputProps={{ readOnly: true, style: {
                backgroundColor: "white"                 
              } }}
              size="small"
              disabled={false}
              focused={false}
              placeholder="Add Last Name"
              fullWidth

              value={data.Mobilenumber}

            />

          </Grid>
        </Grid>

        <Grid className='time_container' style={{ display: 'flex', flexDirection: 'column', marginTop: "19px", boxShadow: 8, padding: '12px', border: '1px solid #E3E3E3', backgroundColor: '#FCFCFC', borderRadius: "6px" }} >
          <Typography style={{ fontWeight: '600', fontFamily: 'Rubik', color: '#000000', marginLeft: '6px', letterSpacing: '0.1px' }}>
            Work Hours
          </Typography>
          <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '1%' }}>
            <Typography sx={{ width: '35%', fontFamily: 'Rubik', color: '#000000', letterSpacing: '0.7px', fontSize:'14px' }}>
              Selected Work Hours
            </Typography>
            
            <TextField
              disabled={false}
              InputProps={{ readOnly: true, style: {
                backgroundColor: "white"                 
              } }}
              focused={false}
              size="small"
              value={"09:30 am"}
              style={{ marginRight: '-103px', color: '#202121', fontSize: '16px' }}

            />
            
            <TextField
              size="small"
              value={"09:30 pm"}
              InputProps={{ readOnly: true, style: {
                backgroundColor: "white"                 
              } }}
              disabled={false}
              focused={false}
              style={{marginLeft:'7%'}}
            />
          </div>
        </Grid>

      </Grid>
      <Grid >
        <img className="icon"
          style={{ marginTop: '20px', margin: '12px' }}
          src={data.Insidepic}
          alt="link"
        />
      </Grid>
    </Grid>



  )
}

export default Section1;